import { HubSpotChat } from '@components/ui/HubspotChat/HubspotChat';
import { ChatwootChat } from '@components/ui/ChatwootChat/ChatwootChat';
import { CHAT_PROVIDER } from '@app/utils/supportChat';

// Provider-Weiche für den Support-Chat: VITE_CHAT_PROVIDER=chatwoot schaltet
// auf das selbst gehostete Chatwoot-Widget um, Default bleibt HubSpot.
export function ChatWidget() {
  return CHAT_PROVIDER === 'chatwoot' ? <ChatwootChat /> : <HubSpotChat />;
}
